export { BaseAssertException } from './base-assert.exception';
export { IllegalArgumentException } from './illegal-argument.exception';
export { IllegalStateException } from './illegal-state.exception';
